import React from 'react';
import { styled } from 'styled-components';
const Errors = (props) => {
    return (React.createElement(ErrorsStyled, null, [...new Set(props.errors)].map((error) => (React.createElement("div", { key: error, className: "warning" }, error)))));
};
export default Errors;
const ErrorsStyled = styled.div `
  width: 100%;

  .warning {
    border-radius: 3px;
    background-color: #ff5252;
    padding: 12px 15px;
    font-size: 0.8em;
    margin-bottom: 20px;
    width: 100%;
    background-image: none;
    border: 1px solid #fa2a2a;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    color: white;
  }
`;
//# sourceMappingURL=Errors.js.map